import { render } from "./GoodTrainingWishView.vue?vue&type=template&id=0d0bd2cc"
import script from "./GoodTrainingWishView.vue?vue&type=script&lang=js"
export * from "./GoodTrainingWishView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__